import type { ComponentPropsWithoutRef } from "react";
import { Button } from "react-aria-components";
import { styled } from "../../../../stitches.config";

export const BaseButton = styled(Button, {
  padding: 0,
  margin: 0,
  border: "none",
  background: "transparent",
  color: "inherit",
  fontSize: "inherit",
  fontWeight: "inherit",
  fontFamily: "inherit",
  lineHeight: "inherit",
  userSelect: "none",
  touchAction: "manipulation",
  "&[data-hovered]": {
    cursor: "pointer",
  },
  "&[data-focus-visible]": {
    boxShadow:
      "var(--colors-borderUiFocused) 0 0 0 2px, var(--colors-blue100) 0 0 0 4px",
  },
  // reset the normalized stylesheet since we use data-focus-visible to style
  // the focus state
  "&:focus-visible": {
    outline: "none",
  },
});

export type BaseButtonProps = ComponentPropsWithoutRef<typeof BaseButton>;
